var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { ReactQuestionFactory, SurveyQuestionText, SvgIcon, attachKey2click } from "survey-react-ui";
var SurveyQuestionFileEditor = /** @class */ (function (_super) {
    __extends(SurveyQuestionFileEditor, _super);
    function SurveyQuestionFileEditor(props) {
        return _super.call(this, props) || this;
    }
    Object.defineProperty(SurveyQuestionFileEditor.prototype, "questionFile", {
        get: function () {
            return this.questionBase;
        },
        enumerable: false,
        configurable: true
    });
    SurveyQuestionFileEditor.prototype.getValueCore = function () {
        return this.question.renderedValue;
    };
    SurveyQuestionFileEditor.prototype.renderInput = function () {
        var _this = this;
        return (React.createElement(React.Fragment, null,
            React.createElement("input", { disabled: this.question.isTextInputReadOnly, className: this.questionFile.cssClasses.control, placeholder: this.questionFile.renderedPlaceholder, ref: function (input) { return (_this.setControl(input)); }, autoComplete: "off", type: "text", onBlur: function (event) { return _this.questionFile.onInputBlur(event.nativeEvent); }, onChange: function (event) { return _this.questionFile.onInputChange(event.nativeEvent); } })));
    };
    SurveyQuestionFileEditor.prototype.renderFileInput = function () {
        var _this = this;
        return (React.createElement("input", { type: "file", disabled: this.isDisplayMode, className: this.questionFile.cssClasses.fileInput, id: this.questionFile.inputId, "aria-required": this.questionFile.ariaRequired, "aria-label": this.questionFile.ariaLabel, "aria-invalid": this.questionFile.ariaInvalid, "aria-describedby": this.questionFile.ariaDescribedBy, multiple: false, title: this.questionFile.inputTitle, accept: this.questionFile.acceptedTypes, tabIndex: -1, onChange: function (event) { return _this.questionFile.onFileInputChange(event.nativeEvent); } }));
    };
    SurveyQuestionFileEditor.prototype.renderButtons = function () {
        return (React.createElement("div", { className: this.questionFile.cssClasses.buttonsContainer },
            this.renderClearButton(),
            this.renderChooseButton()));
    };
    SurveyQuestionFileEditor.prototype.renderClearButton = function () {
        return attachKey2click((React.createElement("button", { className: this.questionFile.cssClasses.clearButton, title: this.questionFile.clearButtonCaption, disabled: this.questionFile.getIsClearButtonDisabled(), onClick: this.questionFile.doClean },
            React.createElement(SvgIcon, { iconName: this.questionFile.cssClasses.clearButtonIcon, size: "auto" }))));
    };
    SurveyQuestionFileEditor.prototype.renderChooseButton = function () {
        var _this = this;
        return (attachKey2click(React.createElement("label", { onClick: function (event) { return _this.questionFile.chooseFiles(event.nativeEvent); }, className: this.questionFile.getChooseButtonCss(), htmlFor: this.questionFile.inputId, "aria-label": this.questionFile.chooseButtonCaption },
            React.createElement(SvgIcon, { iconName: this.questionFile.cssClasses.chooseButtonIcon, size: "auto", title: this.questionFile.chooseButtonCaption }))));
    };
    SurveyQuestionFileEditor.prototype.renderElement = function () {
        var _this = this;
        return (React.createElement("div", { className: this.questionFile.cssClasses.root, ref: function (el) { return _this.setContent(el); }, onDragEnter: this.questionFile.onDragEnter, onDragOver: this.questionFile.onDragOver, onDrop: this.questionFile.onDrop, onDragLeave: this.questionFile.onDragLeave, onKeyDown: function (event) { return _this.question.onKeyDown(event.nativeEvent); } },
            this.renderInput(),
            this.renderFileInput(),
            this.renderButtons()));
    };
    return SurveyQuestionFileEditor;
}(SurveyQuestionText));
export { SurveyQuestionFileEditor };
ReactQuestionFactory.Instance.registerQuestion("fileedit", function (props) {
    return React.createElement(SurveyQuestionFileEditor, props);
});
